import { createAction, props } from '@ngrx/store';
import { inventoryByPlantResponse } from 'src/app/pages/orders/order-taking/components/new-order/models/iExtraProductFilters';

export const loadInventoryByPlant = createAction(
  '[Inventory By Plant] Load',
  props<{ productCode: string; plants: string[]; key: string }>(),
);

export const loadInventoryByPlantSuccess = createAction(
  '[Inventory By Plant] Load Success',
  props<{ key: string; data: inventoryByPlantResponse[] }>(),
);

export const loadInventoryByPlantFailure = createAction(
  '[Inventory By Plant] Load Failure',
  props<{ key: string; error: any }>(),
);

export const clearInventoryByPlantByKey = createAction('[Inventory By Plant] Clear By Key', props<{ key: string }>());
